import React from 'react';
import { cn } from './Button';
interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: 'default' | 'pink' | 'blue' | 'outline';
}
export function Badge({
  className,
  variant = 'default',
  ...props
}: BadgeProps) {
  const variants = {
    default: 'jua-badge-default bg-slate-900/60 text-slate-300 border border-[#EC4899]/25 backdrop-blur-md',
    pink: 'jua-badge-pink bg-[#EC4899]/15 text-[#EC4899] border border-[#EC4899]/30 backdrop-blur-md',
    blue: 'jua-badge-blue bg-blue-500/15 text-blue-400 border border-blue-500/25 backdrop-blur-md',
    outline: 'jua-badge-outline bg-transparent text-slate-400 border border-slate-600/50 backdrop-blur-md'
  };
  return <span className={cn('inline-flex items-center rounded-full px-3 py-0.5 text-xs font-semibold transition-colors', variants[variant], className)} {...props} data-id="element-1120" />;
}